import { collectionEngineV1 } from '../apis.js';
const reqContacts = collectionEngineV1('/contacts');
export const getAll = () => reqContacts('GET', `/`);
export const get = (id) => reqContacts('GET', `/${id}`);
export const create = (contact) => reqContacts('POST', `/`, { body: contact });
export const update = (id, contact) => reqContacts('PATCH', `/${id}`, { body: contact });
export const remove = (id) => reqContacts('DELETE', `/${id}`);
//# sourceMappingURL=contacts.js.map